import type { Brand, Site } from '@ps/web-core-enums';
import { ResolverTag } from '@ps/web-core-store';
import type { CasinoClientPlatform, FeatureFlag, License } from '@ps/web-core-store';

import type { PostMessage } from '@swf/core/enums';

export enum Department {
  Balances = 'balances',
  BankID = 'bankId',
  ConvertCurrencies = 'convert-currencies',
  Deposit = 'deposit',
  History = 'history',
  Home = 'home',
  P2pTransfer = 'p2p-transfer',
  Paywall = 'paywall',
  PlayMoney = 'playmoney',
  PreferredCurrency = 'preferred-currency',
  RMF = 'rmf',
  Withdraw = 'withdraw'
}

export const BonusTags = {
  'free-spin-bonuses': ResolverTag.FreeSpinBonus,
  'instant-bonuses': ResolverTag.InstantBonus,
  bonuses: ResolverTag.BonusesReleaseAndInstant,
  'sports-bonus-cash': ResolverTag.Cashbonus,
  'game-tickets': ResolverTag.MinigameTicket,
  'free-bets': ResolverTag.ISPFreeBets
};

export enum RollType {
  InstantBonuses,
  FreeSpinBonuses,
  GameTickets
}

export interface Data {
  data:
    | {
        command: PostMessage;
        data: { c2l: string };
        arguments: string[];
        msgId: string;
        rollType: number;
      }
    | string;
}

export interface ResolverQuery {
  opencontext?: string;
  ram?: number;
  applePaySupported?: boolean;
  language?: string;
  country?: string;
  userId?: string;
  timezone?: number;
  iceParam?: 'leaderboardid' | 'promoid';
  u?: string;
  platform?: string;
  brand?: string;
}

export interface Params {
  bonusId?: string;
  bonusType: string;
  department: Department;
  icegame?: string;
  icegameId?: string;
  trigger?: string;
}

export interface ResolverProps {
  assetUrl: string;
  brand?: Brand;
  brandName?: string;
  close?(path: string): void;
  country?: string;
  emailValidated: boolean;
  embedded?: boolean;
  embeddedRoute?: boolean;
  features: Partial<{ [key in FeatureFlag]: boolean }>;
  firstSession?: boolean;
  generatePath?(): string;
  getTokenAndSignature(): { token: string; signature: string };
  isPlayMoney?: boolean;
  isRealMoneyOK: boolean;
  isReloader?: boolean;
  language: string;
  license: License;
  locationState: Record<string, string | number>;
  migrationRequired: boolean;
  migrationTarget?: number;
  navigate(path: string): void;
  params: Params;
  pathname: string;
  platform?: CasinoClientPlatform;
  push?(path: string): void;
  routes?: { [key: string]: string };
  setPendingNotifications(): void;
  site?: Site;
  styles?: Record<string, string> & { iframeModal: string };
}

export interface HandleMessageProps {
  c2lHandler(c2l: string): void;
  close?(path?: string): void;
  data: Data['data'];
  dataIntegrityCheckFailed: boolean;
  depositLimitPath: string;
  license: License;
  logout(props?: object): void;
  modalReplace(props: { path: string }[]): void;
  postMessage?(): void;
  push(path: { pathname: string; state: object } | string): void;
  quickAccountCreationRequired: boolean;
  refreshAccount(): void;
  setMitIdWc2Data(props: object): void;
}
